import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MenuConfiguration } from 'src/business/models/main-configuration.model';
import { MediaModule } from 'src/layout/media/media.module';
import { StorageUtil } from 'src/utils/storage.util';

@Component({
  selector: 'app-footer-licenses',
  templateUrl: './footer-licenses.component.html',
  styleUrls: ['./footer-licenses.component.scss'],standalone: true,
  imports:[CommonModule, TranslateModule, MediaModule],

  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterLicensesComponent {
    menu: Partial<MenuConfiguration> = StorageUtil.get<MenuConfiguration>('menu');
    @HostBinding('attr.aria-hidden') ariahidden = this?.menu?.licenses?.length > 0 ? null : '';
    @HostBinding('attr.aria-label') ariaLabel = this._translateService.instant('FOOTER.LICENSES_LABEL')
    constructor(private _translateService: TranslateService) {}


}
